module.exports = __webpack_public_path__ + "static/media/_kosovo.fb70277f.png";